<rid-categorise
  class="h-dvh"
  name="Sorteren | Woord & audio"
  [questions]="[
    {
      id: '1',
      assignment: 'Sleep het woord op het juiste geluid',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
      ],
      answer: 1,
    },
    {
      id: '1.1',
      assignment: 'Sleep het woord op het juiste geluid',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
      ],
      answer: 0,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/categorise'])"
/>
